export const barColors = {
  'sales': {'base': '#4A90E280', 'selected': '#4A90E2'},
  'lostSales': {'base': '#55DBCB80', 'selected': '#55DBCB'},
  'orders': {'base': '#47CBFF80', 'selected': '#47CBFF'},
};

export const labels = {
  'sales': 'Ventas',
  'lostSales': 'Ventas perdidas',
  'orders': 'Pedidos',
};
